import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        component: () =>
            import ('../views/Home.vue'),
        meta: { title: 'Fundamentos de Matemáticas' }
    },

    {
        path: '/accionProblemica',
        name: 'AP',
        component: () =>
            import ('../views/AP.vue'),
        meta: { title: 'Fundamentos de Matemáticas' }
    },

    {
        path: '/conocimientosPrevios',
        name: 'CP',
        component: () =>
            import ('../views/CP.vue'),
        meta: { title: 'Fundamentos de Matemáticas' }
    },

    {
        path: '/Tema1',
        name: 'Tema1',
        component: () =>
            import ('../views/Tema1.vue'),
        meta: { title: 'Fundamentos de Matemáticas' }
    }


]

const router = new VueRouter({
    routes
})

export default router